// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1___39c27fe41b62297e352","cls2":"Cta-cls2___116efeeeedf93bea75e Cta-cls1___39c27fe41b62297e352"};